<div class="wrapper" *ngIf="callNowDetails">
  <ng-container *ngIf="seconds > 0">
    <div class="result-title">{{ '+SERVICE_TICKET.CALL_RESULT_TITLE' | translate }}</div>
    <div class="result-description">
      {{ '+SERVICE_TICKET.CALL_RESULT_CALL_INSTRUCTION' | translate }}:
    </div>
    <div class="result-number">
      {{ callNowDetails.callNumber | formatPhoneNumber }}

      <ng-container *ngIf="(uiService.isMobileView$ | async) || (uiService.isTabletView$ | async)">
        <a href="tel:{{ callNowDetails.callNumber }}">
          <button
            class="m-2"
            mat-raised-button
            mat-button
            gtm="click"
            gtmAction="Call now"
            gtmCategory="ServiceTicket"
            color="primary"
          >
            <mat-icon>phone</mat-icon>
            <span>{{ '+SERVICE_TICKET.CALL_NOW_OPTION_NAME' | translate }}</span>
          </button>
        </a>
      </ng-container>
    </div>
    <div>
      {{ '+SERVICE_TOOL.CALL_NOW_REMAINING_TIME' | translate: { time: time$ | async } }}
    </div>
  </ng-container>

  <ng-container *ngIf="seconds < 1">
    <div class="result-title">{{ '+SERVICE_TICKET.CALL_NOW_EXPIRED_TITLE' | translate }}</div>
    <div class="result-description">
      {{ '+SERVICE_TICKET.CALL_NOW_EXPIRED_DESCRIPTION' | translate }}
    </div>
    <button
      data-at-call-now-btn
      mat-raised-button
      gtm="onSelect"
      gtmAction="Call now again button"
      gtmCategory="ServiceTicket"
      color="primary"
      mat-button
      (click)="onCallNowClicked()"
    >
      <span>{{ '+SERVICE_TICKET.CALL_NOW_BUTTON' | translate }}</span>
    </button>
  </ng-container>
</div>
